import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class StoreLanguageService {
  constructor(private translateService: TranslateService) {}

  public async loadCustomerUiLanguage() {
    const locale = this.resolveLocale();

    try {
      const translations = await this.loadCustomerTranslations(locale);

      this.translateService.setTranslation(locale, translations);
      this.translateService.use(locale);
    } catch (error) {
      const langModule = await import(
        `./translations/i18n/translation.en.json`
      );

      this.translateService.setTranslation('en', langModule.default);
      this.translateService.use('en');
    }
  }

  /** The customer UI translations of one language, without applying them. */
  public async loadCustomerTranslations(
    locale: string,
  ): Promise<Record<string, unknown>> {
    const langModule = await import(
      `./../../app/public/translations/i18n/translation.${locale}.json`
    );
    return langModule.default;
  }

  private resolveLocale(): string {
    const params = new URLSearchParams(window.location.search);
    const fromUrl = params.get('ulang');

    if (fromUrl) return this.normalizeLocale(fromUrl);

    const preferred = navigator.languages?.[0];
    if (preferred) return this.normalizeLocale(preferred);

    return 'en';
  }

  private normalizeLocale(lang: string): string {
    lang = lang.toLowerCase();

    if (lang.includes('-')) {
      return lang.split('-')[0];
    }

    return lang;
  }
}
